import React, { useState, useEffect } from "react";
import AddInput from "../../components/objects/AddInput";
import GainButton from "../../components/objects/GainButton";
import { Select, message } from "antd";

import { getEmissionType, updateScenario } from "../../services/api";
const { Option } = Select;

export default function Update({ data, onFinish }) {
  const [Template, setTemplate] = useState([]);
  const [Formdata, setFormdata] = useState({
    scenario_name: "",
    description: "",
    activity_types_id: null,
  });

  useEffect(() => {
    emissionTypeLists();
  }, []);

  useEffect(() => {
    setFormdata({
      scenario_name: data?.scenario_name,
      description: data?.description,
      activity_types_id: data?.emission_activity_types?.id,
    });
  }, [data]);

  const emissionTypeLists = async () => {
    const res = await getEmissionType();
    const option = res.data.map((item) => ({
      id: item.id,
      name: `Activities type ${item.name}`,
      value: item.template_file_name,
    }));
    setTemplate(option);
  };

  const handleUpdate = async () => {
    const res = await updateScenario(data?.id, Formdata);
    if (res.status == 200) {
      message.success("Updated");
      onFinish();
    }
  };

  return (
    <div className="w-full edit-scenario">
      <div className="pt-5">
        <AddInput
          value={data?.id}
          label="Scenario ID"
          type="text"
          placeholder="First Name"
          disabled
        />
        <AddInput
          value={Formdata.scenario_name}
          label="Scenario name"
          type="text"
          placeholder="First Name"
          onChange={(e) =>
            setFormdata({ ...Formdata, scenario_name: e.target.value })
          }
        />
        <br />
        <div className="grid grid-cols-8">
          <div className="col-span-2">Activities type</div>
          <Select
            value={Formdata.activity_types_id}
            onChange={(e) => setFormdata({ ...Formdata, activity_types_id: e })}
            className="col-span-6"
          >
            {Template.map((option) => (
              <Option value={option.id}>{option.name}</Option>
            ))}
          </Select>
        </div>
        <br />
        <AddInput
          value={Formdata.description}
          label="Description"
          type="textarea"
          placeholder="Description"
          onChange={(e) =>
            setFormdata({ ...Formdata, description: e.target.value })
          }
        />
        <br />
        <AddInput
          value={data?.owner.firstname}
          label="Owner"
          type="text"
          placeholder="Owner"
          disabled
        />
      </div>
      <div className="pt-12" onClick={handleUpdate}>
        <GainButton label="Save" center />
      </div>
    </div>
  );
}
